module.exports = __webpack_public_path__ + "static/media/jx_icon.583103a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/jx_icon.png
// module id = 1993
// module chunks = 6